module.exports = __webpack_public_path__ + "themes/giveandgo/assets/img/lazer-19.4faaadb7.png";